import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";

const ContestLeaderboard = ({ showModal, handleModalToggle, contest }) => {
  const [round1Details, setRound1Details] = useState([]);
  const [round2Details, setRound2Details] = useState([]);
  const [athletePoints, setAthletePoints] = useState(0);

  const [round1Modal, setRound1Modal] = useState(false);
  const [round2Modal, setRound2Modal] = useState(false);

  const round1ModalToggle = () => {
    if (round1Modal) {
      setAthletePoints(0);
    }
    setRound1Modal(!round1Modal);
  };
  const round2ModalToggle = () => setRound2Modal(!round2Modal);

  return (
    <>
      <Modal isOpen={showModal} toggle={handleModalToggle} size="xl" centered>
        <ModalHeader toggle={handleModalToggle}>Leaderboard</ModalHeader>
        <ModalBody>
          <Card
            className="overflow-hidden"
            style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
          >
            <CardHeader className="p-3">
              <h5 className="mb-0 text-uppercase">Leaderboard</h5>
            </CardHeader>
            <CardBody className="p-0">
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Fan Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Rewarded Amount</th>
                    <th scope="col">Total Points</th>
                  </tr>
                </thead>
                <tbody>
                  {contest?.leaderBoard?.length > 0 ?
                    contest?.leaderBoard?.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.fanName}</td>
                        <td>{item?.email}</td>
                        <td>{contest?.rewardedAmount}</td>
                        <td>{item?.totalPoints}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td
                          colSpan={4}
                          className="text-center py-4"
                        >
                          No Data
                        </td>
                      </tr>
                    )}
                </tbody>
              </Table>
            </CardBody>
          </Card>

          {["Round 1", "Round 2"].map((round, idx) => {
            const roundData = idx === 0 ? contest?.round1 : contest?.round2;
            const setDetails = idx === 0 ? setRound1Details : setRound2Details;
            const modalToggle =
              idx === 0 ? round1ModalToggle : round2ModalToggle;

            return (
              <Card
                key={round}
                className="overflow-hidden mt-3"
                style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
              >
                <CardHeader className="p-3">
                  <h5 className="mb-0 text-uppercase">{round}</h5>
                </CardHeader>
                <CardBody className="p-0">
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Fan Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Total Points</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roundData?.length > 0 ? roundData?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.fanName}</td>
                          <td>{item?.email}</td>
                          <td>{item?.totalPoints}</td>
                          <td>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => {
                                setDetails(item?.pointDetails);
                                if (idx === 0) {
                                  setAthletePoints(item?.totalPoints);
                                }
                                modalToggle();
                              }}
                            >
                              View Details
                            </Button>
                          </td>
                        </tr>
                      )) : (
                        <tr>
                          <td
                            colSpan={4}
                            className="text-center py-4"
                          >
                            No Data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            );
          })}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleModalToggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {[round1Details, round2Details].map((details, idx) => {
        const toggle = idx === 0 ? round1ModalToggle : round2ModalToggle;
        const isOpen = idx === 0 ? round1Modal : round2Modal;

        return (
          <Modal key={idx} isOpen={isOpen} toggle={toggle} size="xl" centered>
            <ModalHeader toggle={toggle}>Athlete Details</ModalHeader>
            <ModalBody>
              <Card
                className="overflow-hidden"
                style={{ boxShadow: "1px 1.5px 2px rgba(0, 0, 0, 0.05)" }}
              >
                <CardBody className="p-0">
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        {idx === 0 ? (
                          <>
                            <th scope="col">Athlete Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Athlete ID</th>
                            <th scope="col">Total Points</th>
                          </>
                        ) : (
                          <>
                            <th scope="col">Athlete Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Seasonal Badges</th>
                            <th scope="col">Momentos</th>
                            <th scope="col">Talking Badges</th>
                            <th scope="col">Sport Badges</th>
                            <th scope="col">Endorsement Badges</th>
                            <th scope="col">Chats</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {details?.map((item, index) => (
                        <tr key={index}>
                          {idx === 0 ? (
                            <>
                              <td>
                                {item?.first_name + " " + item?.last_name}
                              </td>
                              <td>{item?.email}</td>
                              <td>{item?.athleteID}</td>
                              <td>{athletePoints}</td>
                            </>
                          ) : (
                            <>
                              <td>
                                {item?.athleteData.first_name +
                                  " " +
                                  item?.athleteData.last_name}
                              </td>
                              <td>{item?.athleteData.email}</td>
                              <td>{item?.seasonal_badges || 0}</td>
                              <td>{item?.momentos || 0}</td>
                              <td>{item?.talking_badges || 0}</td>
                              <td>{item?.sport_badges || 0}</td>
                              <td>{item?.endorsement_badges || 0}</td>
                              <td>{item?.chats || 0}</td>
                            </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={toggle}>
                Close
              </Button>
            </ModalFooter>
          </Modal>
        );
      })}
    </>
  );
};

export default ContestLeaderboard;
